<template>
  <div class="store-fast-order-wrap">
    <div class="order-wrap">
      <div class="order-type">
        <div class="tab" :class="[active == 0 ? 'active' : '']" @click="active = 0">人工输入</div>
        <div class="tab" :class="[active == 1 ? 'active' : '']" @click="active = 1">批量上传</div>
      </div>
      <div class="manual order-custom-wrap" v-if="active == 0">
        <div class="tip">在下表中，输入需要订购的每个商品货号以及数量</div>
        <div class="list" v-loading="loading">
          <div class="item" v-for="(item, index) in manualList" :key="index">
            <div class="search-input">
              <el-input v-model="item.no" placeholder="请输入商品货号" @input="getProductByNo($event, index)">
              </el-input>
              <div class="mgl10">
                <el-input-number v-model="item.num" @change="handleInputNum($event, index)"></el-input-number>
              </div>
            </div>
            <div class="name" v-if="item.product_name">商品名称：{{ item.product_name }}</div>
            <div class="name" v-if="item.loading">搜索中...</div>
            <div class="name colorRed" v-if="item.error">
              商品货号 {{ item.no }} 不存在，请检查
            </div>
          </div>
          <div class="add-line" v-if="!manualList.length">
            <el-empty description="暂无数据"></el-empty>
          </div>
        </div>
        <div class="operate-wrap">
          <div class="add-line">
            <el-input type="number" style="width:250px;" size="small" v-model="addNum">
              <template slot="prepend">再添加</template>
              <template slot="append">行</template>
            </el-input>
            <img src="~@/assets/images/fast_order_add_icon.png" alt="" @click="handleAddList">
          </div>
          <el-button class="add-store-car flex-cc float-end" @click="handleAddCart">加入购物车</el-button>
        </div>
      </div>
      <div class="batch-upload order-custom-wrap" v-if="active == 1">
        <div class="upload-wrap">
          <el-upload class="upload" drag :action="uploadAction" :data="uploadData" :headers="uploadHeader"
            :file-list="fileList" :multiple="false" :show-file-list="true" :limit="1" :on-remove="handleRemove"
            :on-success="handleUploadFileSuccess" :before-remove="beforeRemove" accept=".xls,.xlsx">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只能上传xls/xlsx文件，且不超过500kb</div>
          </el-upload>
          <div class="upload-model">
            <p class="upload-title">下载导入模板</p>
            <div class="download-model"><img src="~@/assets/images/download_model_icon.png" alt=""
                @click="download">下载模板
            </div>
          </div>
        </div>
        <div class="table-wrap mgt20" v-loading="loading">
          <el-table :data="multiList" v-loading="loading" element-loading-text="给我一点时间" :empty-text="emptyText" border
            fit highlight-current-row>
            <el-table-column label="货号" align="center" minWidth="150" prop="no">
            </el-table-column>
            <el-table-column label="商品名称" align="center" minWidth="150" prop="product_name">
            </el-table-column>
            <el-table-column label="品牌" align="center" minWidth="150" prop="brand_name">
            </el-table-column>
            <el-table-column label="数量（件）" align="center" minWidth="150" prop="num">
            </el-table-column>
            <el-table-column label="单价（元）" align="center" minWidth="150" prop="price">
            </el-table-column>
            <el-table-column label="总价（元）" align="center" minWidth="150">
              <template slot-scope="scope">{{ scope.row.num * scope.row.price }}</template>
            </el-table-column>
            <el-table-column label="操作" align="center" minWidth="150">
              <template slot-scope="scope">
                <el-button type="text" class="btn" @click="handleDelete(scope)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-button class="add-store-car flex-cc" @click="handleAddCart">加入购物车</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import { getProductByNo, addCartMulti } from "@/api/cart";
import { importPreview } from "@/api/common";
import { objKeySort } from '@/utils/auth'
import { getStorage } from '@/utils/auth'
export default {
  name: "OrderStoreFast",
  components: {

  },
  props: {},
  data() {
    return {
      active: 0,
      loading: false,
      addNum: 1,
      emptyText: '暂无数据',
      downloadUrl: '',
      manualList: [],
      multiList: [],
      uploadAction: process.env.VUE_APP_BASE_API + 'common/uploadExcel',
      uploadHeader: { Authorization: getStorage('token') },
      uploadData: {
        sign: objKeySort([])[2]
      },
      fileList: []
    }
  },
  computed: {

  },
  created() {
    this.formatPrice = this.utils.formatPrice
    this.getQuickPreview()
  },
  mounted() {

  },
  updated() {

  },
  methods: {
    handleUploadFileSuccess(res, file) {
      console.log(1111, file)
      console.log(222, res)
      this.fileList.push(res.data.file)
      this.multiList = this.multiList.concat(res.data.list)
      console.log(this.multiList)
    },
    handleDelete(scope) {
      this.multiList.splice(scope.$index, 1)
    },
    handleRemove(file, fileList) {
      this.fileList = fileList
      console.log(file, fileList)
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleInputNum(val, index) {
      if (val == 0) this.manualList.splice(index, 1)
    },
    getQuickPreview() {
      importPreview({ type: 'quick' }).then(res => {
        this.downloadUrl = res.data.url
      })
    },
    getProductByNo(val, index) {
      if (!val) return;
      console.log(val, index)
      this.manualList[index].loading = true;
      getProductByNo({ no: val }).then(res => {
        this.manualList[index].loading = false;
        this.manualList[index].product_name = res.data.product_name
        this.manualList[index].brand_name = res.data.brand_name
        this.manualList[index].product_id = res.data.product_id
        this.manualList[index].specs_id = res.data.specs_id
        if (res.data.product_id == 0) {
          this.manualList[index].error = 1;
        } else {
          this.manualList[index].error = 0;
        }
      })
    },
    handleAddCart() {
      const _list = JSON.parse(JSON.stringify(this.active == 0 ? this.manualList : this.multiList));
      if (_list.length == 0) return this.$message.error('请添加商品')
      if (this.active == 0) {
        for (let i = 0; i < _list.length; i++) {
          if (_list[i].error == 1) {
            return this.$message.error('请输入正确的货号')
          }
        }
      }
      if (this.active == 0) {
        const _list = JSON.parse(JSON.stringify(this.manualList));
        for (let i = 0; i < _list.length; i++) {
          if (_list[i].num == 0) {
            return this.$message.error('请输入数量')
          }
        }
      }
      this.loading = true;
      addCartMulti({ list: _list }).then((res) => {
        this.loading = false;
        this.$message.success('操作成功'), setTimeout(() => {
          this.$router.push({
            path: '/store_order/add'
          })
        }, 1000)
      }).catch(err => {
        this.loading = false;
      })
    },
    handleAddList() {
      for (let i = 0; i < this.addNum; i++) {
        this.manualList.push({
          specs_id: 0,
          product_id: 0,
          no: '',
          goods_name: '',
          brand_name: '',
          num: 1,
          price: 0,
          loading: false,
          error: 0
        })
      }
    },
    download() {
      window.open(this.downloadUrl, '_blank');
    }
  }
};
</script>
<style lang="scss" scoped>
.store-fast-order-wrap {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 141px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #F4F8F9;

  .order-wrap {
    width: 1200px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .order-type {
      width: 100%;
      display: flex;
      align-items: center;
      column-gap: 20px;
      margin-bottom: 20px;

      .tab {
        background: #D4EEF6;
        border-radius: 4px;
        padding: 7px 33px;
        font-size: 16px;
        font-weight: 400;
        color: #00B4E8;
        cursor: pointer;
      }

      .active {
        color: #FFFFFF;
        background: #00B4E8;
      }
    }

    .batch-upload {
      .upload-wrap {
        display: grid;
        grid-template-columns: 700px auto;
        column-gap: 15px;

        .upload,
        .upload-model {
          width: 100%;
          padding: 14px 20px;
          box-sizing: border-box;
          background: #F4F8F9;
          border-radius: 4px 4px 4px 4px;
        }

        .upload-model {
          .upload-title {
            font-size: 14px;
            font-weight: 300;
            color: #6F7F84;
          }

          .download-model {
            width: 166px;
            height: 41px;
            background: #FFFFFF;
            border-radius: 4px;
            border: 1px solid #00B4E8;
            display: flex;
            align-items: center;
            justify-content: center;
            column-gap: 3px;
            font-size: 14px;
            font-weight: 300;
            color: #00B4E8;
            margin-top: 11px;
            cursor: pointer;
          }
        }

        .upload {
          .upload-title {
            font-size: 14px;
            font-weight: 300;
            color: #6F7F84;
          }


          .upload-action-wrap {
            width: 100%;
            height: 112px;
            border-radius: 4px;
            border: 1px dashed #A0A9AC;
            margin-top: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            row-gap: 10px;
            cursor: pointer;

            .upload-drag-tip {
              font-size: 14px;
              color: #6F7F84;

              i {
                color: #00B4E8;
                font-weight: bold;
              }
            }

            .upload-file-tip {
              font-size: 14px;
              font-weight: 300;
              color: #CCD7DB;
            }
          }

          .dragover {
            border-color: #626262;
            background-color: #FFFFFF;
          }
        }
      }

      .add-store-car {
        width: 160px;
        height: 40px;
        background: #00B4E8;
        border-radius: 20px 20px 20px 20px;
        font-size: 13px;
        font-weight: 300;
        color: #FFFFFF;
        margin-top: 5px;
        cursor: pointer;
        float: right;
      }
    }

    .manual {
      .tip {
        width: 100%;
        padding: 10px 20px;
        box-sizing: border-box;
        background: #E9F3F6;
        border-radius: 4px;
        font-size: 14px;
        font-weight: 300;
        color: #6F7F84;
      }

      .list {
        width: 100%;
        display: flex;
        flex-direction: column;
        row-gap: 10px;
        margin-top: 20px;

        .item {
          width: 100%;

          .search-input {
            width: 100%;
            background: #FFFFFF;
            border-radius: 4px;

            display: flex;
            align-items: center;
            justify-content: space-between;

          }

          .name {
            width: 100%;
            font-size: 13px;
            font-weight: 300;
            color: #CCD7DB;
            margin-top: 10px;
            padding-left: 10px;
            box-sizing: border-box;
          }
        }
      }

      .operate-wrap {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 40px;

        .add-line {
          display: flex;
          align-items: center;
          column-gap: 12px;
          font-size: 14px;
          font-weight: 400;
          color: #222222;

          img {
            cursor: pointer;
            width: 20px;
            height: 20px;
          }

          input {
            border: none;
            border-bottom: 1px solid #222222;
            outline: none;
            text-decoration: dashed;
            width: 50px;
            text-align: center;
          }
        }

        .add-store-car {
          width: 160px;
          height: 40px;
          background: #00B4E8;
          border-radius: 20px 20px 20px 20px;
          font-size: 13px;
          font-weight: 300;
          color: #FFFFFF;
          margin-top: 5px;
          cursor: pointer;
        }
      }
    }

    .order-custom-wrap {
      width: 100%;
      padding: 20px 15px;
      box-sizing: border-box;
      background: #FFFFFF;
      border-radius: 4px;
      opacity: 1;
      border: 1px solid #00B4E8;
    }

  }
}
</style>
